export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/ob-step-6.png?7ed9b7366256e0b7826ab4e1efc5eb06";